export const poster = {
    img: "/Images/champions-bg2.jpg",
    bayernLogo: "/Images/bayernLogo.png",
    madridLogo: "/Images/madridLogo.png",
    bayernName: "FC Bayern München",
    realName: "Real Madrid CF",
    title: "Champions League Night",
    description: "Quarter Final - 2nd Leg ",
    stadium: "Allianz Arena - Munich",
    date: "April 2026 | 20:00 CET 16"
}

export const cards = [
    {
        id: 1,
        category: "Champions League",
        title_en: "Bayern take advantage Madrid",
        desc_en: " Bayern secured a valuable 2-1 victory over Real Madrid in the first leg in santiago bernabeu.",
        img: "/Images/double-goals.png",
        icon: "bi-trophy"
    },

    {
        id: 2,
        category: "Champions League",
        title_en: "Bayern prepare for decisive Real Madrid clash",
        desc_en: "Final training session complete at Allianz Arena ahead of the Champions League seconde leg.",
        img: "/Images/training.png",
        icon: "bi-trophy"
    },

    {
        id: 3,
        category: "Team News",
        title_en: "Bayern assess squad fitness ahead of Real Madrid clash",
        desc_en: "The team monitors player fitness and possible injuries before the decisive Champions ...",
        img: "/Images/fitness.png",
        icon: "bi-people-fill"
    },

    {
        id: 4,
        category: "Bundesliga",
        title_en: "Bayern maintain strong form in domestic league",
        desc_en: "The team continues to achieve positive results in the German league, ...",
        img: "/Images/pauli-game.png",
        icon: "bi-graph-up"
    },

    {
        id: 5,
        category: "Team Training",
        title_en: "Key Bayern players return to full fitness",
        desc_en: "Several first-team players have returned to full training, at a critical juncture of the season, ...",
        img: "/Images/training2.png",
        icon: "bi-lightning-charge-fill"
    },

    {
        id: 6,
        category: "Fans",
        title_en: "Bayern fans create electric atmosphere ahead of big clash",
        desc_en: "All tickets for the seconde leg match against Real Madrid have been completely sold out.",
        img: "/Images/fans2.jpg",
        icon: "bi-megaphone-fill"
    }
]

export const details = [
    {
        id: 1,
        info: "Bayern take advantage Madrid",
        all_details: `Bayern secured a valuable 2-1 victory over Real Madrid in the first leg at the Santiago Bernabéu, putting them in a strong position for the return leg.
                      The German giants displayed clinical finishing and tactical discipline to overcome the intense atmosphere in Madrid. This crucial away win gives Vincent Kompany's side a significant advantage as they look to secure their spot in the semi-finals.
                      The match was defined by standout performances from Harry Kane and Luis Díaz, who exploited gaps in the Madrid defense with clinical precision. Despite a late surge from the hosts, 
                      Bayern’s backline remained resilient under immense pressure during the closing minutes. Manuel Neuer’s acrobatic saves proved vital in maintaining the lead against Real’s world-class attacking front.
                      Fans are now eagerly anticipating the second leg at the Allianz Arena,
                      where the atmosphere is expected to be electric. This victory reinforces Bayern's status as serious contenders for the Champions League trophy this season. `,
        img: "/Images/KaneReaction.png",
        date:"7 / Apr / 2026"
    },

    {
        id: 2,
        info: "Bayern prepare for decisive Real Madrid clash",
        all_details: `Bayern prepare for decisive Real Madrid clash as the tension reaches its peak ahead of the Champions League second leg.
                      After their hard-fought victory in the first leg, the Bavarian side is leaving nothing to chance in their tactical drills at Säbener Straße.
                      The coaching staff is reportedly focusing on high-intensity pressing and quick transitions to neutralize Madrid’s midfield creativity.
                      Every player is fully aware that maintaining focus for the full 90 minutes is the only way to survive the Spanish giants' comeback attempts.
                      The return of key defensive figures from minor injuries has provided a massive boost to the squad's overall morale and depth.` ,
        img: "/Images/trainManu.png",
        date:"10 / Apr / 2026"
    },

    {
        id: 3,
        info: "Bayern assess squad fitness ahead of Real Madrid clash",
        all_details: `Bayern assess squad fitness ahead of Real Madrid clash as the medical department works around the clock to ensure every key player is ready for the high-stakes encounter.
                      The coaching staff is closely monitoring the recovery progress of several starters who picked up knocks in their recent domestic fixture.
                      There is optimism surrounding the return of their leading playmaker, whose vision on the pitch could be the difference-maker against the Spanish side.
                      The training sessions have been carefully calibrated to balance tactical intensity with physical preservation to avoid any late setbacks.
                      Fitness coaches are utilizing advanced tracking data to manage the workload of veterans and younger talents alike.
                      A final decision on the starting eleven will likely be made just hours before kickoff following a series of late fitness tests.
                      With the stakes so high, the depth of the squad will be tested as they aim to field the strongest possible lineup for this European showdown.`,
        img: "/Images/training3.png",
        date:"10 / Apr / 2026"
    },

    {
        id: 4,
        info: "Bayern maintain strong form in domestic league",
        all_details: `Bayern maintain strong form in domestic league" as they continue to dominate their rivals with a series of convincing victories.
                      The team’s tactical fluidity has allowed them to rotate the squad effectively without losing their competitive edge on the pitch.
                      This consistent performance has solidified their position at the top of the table, creating a comfortable cushion ahead of their pursuers.
                      The defensive line has shown remarkable discipline, keeping multiple clean sheets and frustrating even the most aggressive attacking teams.
                      Offensively, the chemistry between the wingers and the central strikers has reached a peak, resulting in a high goal-scoring average per game.
                      Such domestic stability provides the perfect psychological boost for the players as they shift their focus toward European challenges. Management and fans alike are delighted with the team's professional approach to every fixture,
                      regardless of the opponent's stature.`,
        img: "/Images/celebrate.png",
        date:"11 / Apr / 2026"
    },

    {
        id: 5,
        info: "Key Bayern players return to full fitness",
        all_details: ` Bayern players return to full fitness at a critical juncture of the season,
                       providing a massive tactical boost to the first-team squad. The medical department has finally cleared several long-term absentees to rejoin collective training sessions after successful rehabilitation programs.
                       This influx of experienced talent allows the manager to implement a more aggressive rotation strategy to manage fatigue across multiple competitions. 
                       The returning stars have wasted no time, showcasing their sharpness and technical quality during high-intensity tactical drills at the training ground.
                       Having a full-strength roster creates healthy competition for starting spots, driving every individual to elevate their performance levels to the maximum.
                       Coaches are particularly pleased with the physical data coming from the latest GPS tracking reports, indicating that the players are ready for the 90-minute demands.
                       As the team enters the final stretch of the campaign, this clean bill of health could be the deciding factor in their pursuit of silverware.`,
        img: "/Images/training4.png",
        date:"13 / Apr / 2026"
    },

    {
        id: 6,
        info: "Bayern fans create electric atmosphere ahead of big clash",
        all_details: `Bayern fans create electric atmosphere ahead of big clash as thousands of supporters gather to turn the city into a sea of red and white.
                      The legendary "Sudkurve" has spent weeks preparing elaborate choreographies and massive banners to inspire the team from the stands.
                      From early morning, the streets surrounding the Allianz Arena have been filled with chants and songs that showcase the deep-rooted passion of the Bavarian faithful.
                      This overwhelming show of loyalty serves as a "twelfth man," providing the players with an extra surge of energy during the most difficult moments of the game.
                      Security measures have been ramped up to ensure the safety of the crowds while still allowing the traditional pre-match festivities to flourish. Inside the stadium, the noise levels are expected to break records,
                      creating a daunting environment for the visiting opponents. For many fans, this is more than just a football match; it is a celebration of the club's identity and its prestigious European legacy .`,
        img: "/Images/fans.jpg",
        date:"15 / Apr / 2026"
    }
]
